const coloresPorTipo = {
    temperatura: "#FF6384",
    suelo: "#FFCE56",
    iluminacion: "#9966FF",
    humedadRelativa: "#4BC0C0",
};

const coloresPorDia = {
    0: '#FF6384',
    1: '#36A2EB',
    2: '#FF9933',
    3: '#4CAF50',
    4: '#9966CC',
    5: '#FFCE56',
    6: '#FF5733',
};

const coloresPorSemana = [
    '#4CAF50',
    '#2196F3',
    '#FF9800',
    '#F44336',
    '#9C27B0',
    '#607D8B',
];

const coloresPorMes = [
    '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9933',
    '#5C88DA', '#A0D73D', '#F27976', '#996633', '#FFB4E8', '#A7B9C7',
];

export const formatearDatos = (rawData, titulo, tipo, fechas, filtro) => {
        const { fechaInicio, fechaFin } = fechas;
        const datosFiltrados = rawData.filter(item => {
            const fechaItem = new Date(item.fecha);
            return fechaItem >= fechaInicio && fechaItem <= fechaFin;
        });

        if (filtro === "semana") {
            const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
            const datasets = [];
            const datosPorDia = {};
            const horas = Array.from({ length: 24 }, (_, i) => `${i.toString().padStart(2, '0')}:00`);
            datosFiltrados.forEach(item => {
                const fecha = new Date(item.fecha);
                const dia = fecha.getDay();
                const hora = fecha.getHours();
                if (!datosPorDia[dia]) {
                    datosPorDia[dia] = {};
                }
                if (!datosPorDia[dia][hora]) {
                    datosPorDia[dia][hora] = [];
                }
                datosPorDia[dia][hora].push(item.valor);
            });

            diasSemana.forEach((diaNombre, diaIndice) => {
                if (datosPorDia[diaIndice]) {
                    const dataPuntos = horas.map(horaStr => {
                        const hora = parseInt(horaStr.split(':')[0]);
                        const valoresHora = datosPorDia[diaIndice][hora] || [];
                        return valoresHora.length > 0 ? valoresHora.reduce((a, b) => a + b, 0) / valoresHora.length : null;
                    });
                    datasets.push({
                        label: diaNombre,
                        data: dataPuntos,
                        borderColor: coloresPorDia[diaIndice],
                        backgroundColor: coloresPorDia[diaIndice],
                        fill: false,
                        tension: 0.3,
                        pointRadius: 1,
                        pointHoverRadius: 1,
                    });
                }
            });

            return { labels: horas, data: datasets, raw: datosFiltrados, titulo, tipo };

        } else if (filtro === "mes") {
            const datosFiltradosOrdenados = datosFiltrados.sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

            const labels = datosFiltradosOrdenados.map(item => {
                const fecha = new Date(item.fecha);
                const dia = String(fecha.getDate()).padStart(2, '0'); // Día del mes
                return dia;
            });

            const valores = datosFiltradosOrdenados.map(item => item.valor);

            const datasets = [{
                label: titulo,
                data: valores,
                borderColor: coloresPorTipo[tipo] || "#999",
                backgroundColor: coloresPorTipo[tipo] || "#999",
                fill: false,
                tension: 0.3,
                pointRadius: 3,
                pointHoverRadius: 5,
            }];
            /*
            const datosPorDia = {};
            const fechasUnicas = [];

            datosFiltrados.forEach(item => {
                const fecha = new Date(item.fecha).toISOString().split('T')[0];
                if (!datosPorDia[fecha]) {
                    datosPorDia[fecha] = { total: 0, count: 0 };
                    fechasUnicas.push(fecha);
                }
                datosPorDia[fecha].total += item.valor;
                datosPorDia[fecha].count++;
            });

            fechasUnicas.sort();

            const labels = fechasUnicas.map(fecha => new Date(fecha).getDate().toString());
            const promediosDiarios = fechasUnicas.map(fecha => datosPorDia[fecha].total / datosPorDia[fecha].count);

            const datasets = [{
                label: titulo,
                data: promediosDiarios,
                borderColor: coloresPorTipo[tipo] || "#999",
                backgroundColor: coloresPorTipo[tipo] || "#999",
                fill: false,
                tension: 0.3,
                pointRadius: 3,
                pointHoverRadius: 5,
            }];
            */
            return { labels: labels, data: datasets, raw: datosFiltrados, titulo, tipo };

        } else if (filtro === "año") {
            /*
            const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

            const datasets = [];
            const datosPorMes = {};
            const dias = Array.from({ length: 31 }, (_, i) => `${(i + 1).toString().padStart(2, '0')}`); // "01" a "31"

            // Agrupar por mes y día
            datosFiltrados.forEach(item => {
                const fecha = new Date(item.fecha);
                const mes = fecha.getMonth(); // 0 = Enero
                const dia = fecha.getDate();  // 1 a 31

                if (!datosPorMes[mes]) {
                    datosPorMes[mes] = {};
                }
                if (!datosPorMes[mes][dia]) {
                    datosPorMes[mes][dia] = [];
                }
                datosPorMes[mes][dia].push(item.valor);
            });

            // Generar datasets por mes
            meses.forEach((mesNombre, mesIndice) => {
                if (datosPorMes[mesIndice]) {
                    const dataPuntos = dias.map(diaStr => {
                        const dia = parseInt(diaStr);
                        const valoresDia = datosPorMes[mesIndice][dia] || [];
                        return valoresDia.length > 0
                            ? valoresDia.reduce((a, b) => a + b, 0) / valoresDia.length
                            : null;
                    });

                    datasets.push({
                        label: mesNombre,
                        data: dataPuntos,
                        borderColor: coloresPorMes[mesIndice] || "#999",
                        backgroundColor: coloresPorMes[mesIndice] || "#999",
                        fill: false,
                        tension: 0.3,
                        pointRadius: 2,
                        pointHoverRadius: 3,
                    });
                }
            });
            */
            
            const datosFiltradosOrdenados = datosFiltrados.sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

            const labels = datosFiltradosOrdenados.map(item => {
                const fecha = new Date(item.fecha);
                return fecha.toLocaleString('es-ES', { month: 'short' }); // "ene", "feb", etc.
            });

            const valores = datosFiltradosOrdenados.map(item => item.valor);

            const datasets = [{
                label: titulo,
                data: valores,
                borderColor: coloresPorTipo[tipo] || "#999",
                backgroundColor: coloresPorTipo[tipo] || "#999",
                fill: false,
                tension: 0.3,
                pointRadius: 3,
                pointHoverRadius: 5,
            }];
            /*
            const promediosPorMes = Array(12).fill(null);
            const mesesNombres = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
            const datosPorMes = {};
            datosFiltrados.forEach(item => {
                const mes = new Date(item.fecha).getMonth();
                if (!datosPorMes[mes]) {
                    datosPorMes[mes] = [];
                }
                datosPorMes[mes].push(item.valor);
            });
            for (const mes in datosPorMes) {
                const valoresDelMes = datosPorMes[mes];
                const promedio = valoresDelMes.reduce((a, b) => a + b, 0) / valoresDelMes.length;
                promediosPorMes[mes] = promedio;
            }
            const datasets = [{
                label: titulo,
                data: promediosPorMes,
                borderColor: coloresPorTipo[tipo] || "#999",
                backgroundColor: coloresPorTipo[tipo] || "#999",
                fill: false,
                tension: 0.3,
                pointRadius: 3,
                pointHoverRadius: 5,
            }];
            */
            return { labels: labels, data: datasets, raw: datosFiltrados, titulo, tipo };
        } else {
            const datosFiltradosOrdenados = datosFiltrados.sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

            const labels = datosFiltradosOrdenados.map(item => {
                const fecha = new Date(item.fecha);
                const hours = String(fecha.getHours()).padStart(2, '0');
                const minutes = String(fecha.getMinutes()).padStart(2, '0');
                return `${hours}:${minutes}`;
            });

            const valores = datosFiltradosOrdenados.map(item => item.valor);

            const datasets = [{
                label: titulo,
                data: valores,
                borderColor: coloresPorTipo[tipo] || "#999",
                backgroundColor: coloresPorTipo[tipo] || "#999",
                fill: false,
                tension: 0.3,
                pointRadius: 3,
                pointHoverRadius: 5,
            }];

            return {
                labels: labels,
                data: datasets,
                raw: datosFiltrados,
                titulo,
                tipo,
            };
        }
    };